/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type TermType =
  /** プライバシーポリシー */
  | 'PRIVACY_POLICY'
  /** 通信の秘密 */
  | 'SECRECY_OF_COMMUNICATIONS'
  /** 利用規約 */
  | 'TERMS_OF_SERVICE';

export type AgreementViewRequiredAgreementTermsFragment = { requiredAgreementTerms: Array<{ id: string, type: Types.TermType, title: string, body: MarkdownString }> };

export const AgreementViewRequiredAgreementTermsFragmentDoc = gql`
    fragment AgreementViewRequiredAgreementTerms on Viewer {
  requiredAgreementTerms {
    id
    type
    title
    body
  }
}
    `;